import styled from "styled-components";

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 60px;
`;
export const HoursWrapper = styled.div``;
export const RegularHoursWrraper = styled.div``;
